import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel, Select } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { useState } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { RecycleButton } from "../../components/buttons/recycle";
import { RemoveButton } from "components/buttons/remove";
import ReasonType from "@warriortrading/warriortrading.hermes.common.feathers/enums/reasonType";
import Status from "@warriortrading/warriortrading.hermes.common.feathers/enums/status";

export const CommonReasonsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    filters: {
      initial: [
        {
          field: "status",
          operator: "eq",
          value: 0,
        },
      ],
    },
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc",
        },
      ],
    },
    pagination: {
      pageSize: 10,
    },
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
        hideable: false,
      },
      {
        field: "code",
        headerName: "Code",
        minWidth: 80,
        hideable: false,
      },
      {
        field: "sortNo",
        headerName: "SortNo",
        minWidth: 80,
        hideable: false,
      },
      {
        field: "status",
        headerName: "Status",
        minWidth: 80,
        hideable: false,
        renderCell: function render({ row }) {
          return Status.fromValue(row.status).name;
        },
      },
      {
        field: "content",
        headerName: "Content",
        minWidth: 200,
        flex: 1,
        hideable: false,
      },
      {
        field: "name",
        headerName: "Name",
        minWidth: 80,
        flex: 1,
        hideable: false,
      },
      {
        field: "reasonType",
        headerName: "ReasonType",
        minWidth: 150,
        hideable: false,
        renderCell: function render({ row }) {
          return ReasonType.fromValue(row.reasonType).name;
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 150,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              {row.status === 0 ? (
                <RemoveButton hideText recordItemId={row.id} />
              ) : (
                <RecycleButton hideText recordItemId={row.id} />
              )}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  // search parts
  const [code, setCode] = useState("");
  const [content, setContent] = useState("");
  const [name, setName] = useState("");
  const [reasonTypeSearch, setReasonTypeSearch] = useState<any>("");
  const [statusTypeSearch, setStatusTypeSearch] = useState<any>("0");
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (code) {
      searchArr.push({
        field: "code[$ilike]",
        value: `%${code}%`,
        operator: "eq",
      });
    }
    if (content) {
      searchArr.push({
        field: "content[$ilike]",
        value: `%${content}%`,
        operator: "eq",
      });
    }
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    if (reasonTypeSearch || reasonTypeSearch === 0) {
      searchArr.push({
        field: "reasonType",
        value: `${reasonTypeSearch}`,
        operator: "eq",
      });
    }
    searchArr.push({
      field: "status",
      value: `${statusTypeSearch}`,
      operator: "eq",
    });
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setCode("");
    setContent("");
    setName("");
    setReasonTypeSearch("");
    setStatusTypeSearch("0");
  };

  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Code"
                variant="standard"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Content"
                variant="standard"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "30%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <FormControl style={{ width: "30%" }}>
                <InputLabel id="reasonType">ReasonType : </InputLabel>
                <Select
                  labelId="reasonType"
                  value={reasonTypeSearch as any}
                  label="ReasonType"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setReasonTypeSearch(event.target.value as any);
                  }}
                >
                  {Object.values(ReasonType)[1]
                    .filter((item: any) => item.value !== ReasonType.MOVE.value)
                    .map((item: any) => {
                      return (
                        <MenuItem key={item.value} value={item.value}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              <FormControl style={{ width: "30%" }}>
                <InputLabel id="status">Status : </InputLabel>
                <Select
                  labelId="status"
                  value={statusTypeSearch as any}
                  label="Status"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setStatusTypeSearch(event.target.value as any);
                  }}
                >
                  {Object.values(Status)[0].map((item: any) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <div style={{ width: "30%", paddingBottom: "7px" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
